import restUtils from "core/utils/rest";
import {
  NotificationEditionPayload,
  NotificationHistoryItem,
  notificationHistoryItemTransformer,
  NotificationPreviewResponse,
  NotificationSendPayload
} from "./transformers/notification";

export const getInvestorNotificationHistory = (investorId: string): Promise<NotificationHistoryItem[]> => {
  const url = `hubwise-api/aml/${investorId}/notifications`;
  return restUtils.call("PortalApi", url, "GET").then((response: any) => {
    return response.rows.map(notificationHistoryItemTransformer).sort((a: NotificationHistoryItem, b: NotificationHistoryItem) => {
      const dateTimeA = a.sentDate + a.sentTime;
      const dateTimeB = b.sentDate + b.sentTime;
      return dateTimeB.localeCompare(dateTimeA);
    });
  });
};

export const sendNotification = (investorId: string, payload: NotificationSendPayload) => {
  const url = `hubwise-api/aml/investors/${investorId}/evidence-requests/notification`;
  return restUtils.call("PortalApi", url, "POST", payload);
};

export const previewNotification = (investorId: string, payload: NotificationSendPayload): Promise<NotificationPreviewResponse> => {
  const url = `hubwise-api/aml/investors/${investorId}/evidence-requests/notification?preview=true`;
  return restUtils.call("PortalApi", url, "POST", payload).then((response: any) => {
    return response?.payload?.[0];
  });
};

export const confirmNotificationEdition = (investorId: string, payload: NotificationEditionPayload) => {
  const url = `/aml/investors/${investorId}/evidence-requests/notification/${payload.notfnUrn}`;
  return restUtils.call("PortalApi", url, "PUT", payload);
};
